<template>
    <span class="field list-field">
        <select v-model="innerValue" @change="handleChange">
            <option value=""></option>
            <option v-for="(value,key) in token.acceptedValues" :value="key">{{ value }}</option>
        </select>
    </span>
</template>

<script>
    //import Component from 'path/to/component'
    import FormElementMixin from '@/mixins/formElement.js'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {},
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            handleChange(){
                this.$emit('validate')
            }
        },
        mixins:[
            FormElementMixin
        ],
        mounted: function () {

        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/elements/List.vue